import React from 'react'

const YouTubeComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default YouTubeComponent
